import React from "react";
import { useState, useEffect } from "react";
import Navbar from "./Navbar";
import { checkPassword } from "../extra/checkPassword";
import { fullDate } from "../extra/date";

import styles from "./notes.module.css";
import modalStyle from "./modal.module.css";
import link from "./link.module.css";
const filterDataLink = (value) => {
  let data = value.toUpperCase();
  let allLinks = document.getElementById("links");
  let eachLink = allLinks.getElementsByClassName("link_card__5W2M1");
  for (let i = 0; i < eachLink.length; i++) {
    let a = eachLink[i];
    let txtValue = a.textContent || a.innerText;
    if (txtValue.toUpperCase().indexOf(data) > -1) {
      eachLink[i].style.display = "";
    } else {
      eachLink[i].style.display = "none";
    }
  }
};
const Checklist = () => {
  let db = window.data_base;
  const defaultData = {
    title: "",
    link: "",
  };
  // For thr form
  const [addForm, setAddForm] = useState(defaultData);
  const [updateForm, setUpdateForm] = useState(defaultData);
  const [valid, setValid] = useState(true);
  const [currentId, setCurrentId] = useState("");
  const [addModal, setAddModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);

  const [display, setDisplay] = useState([]);

  // Inital Check and show links
  useEffect(() => {
    const dbName = window.dbnewName;
    const dbVersion = window.dbVer;
    const request = indexedDB.open(dbName, dbVersion);
    request.onsuccess = (e) => {
      checkPassword(e.target.result);
      showData();
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setValid(true);
    if (addForm.title.length > 2 && addForm.link.length > 5) {
      setValid(false);
    }
  }, [addForm]);

  useEffect(() => {
    setValid(true);
    if (updateForm.title.length > 2 && updateForm.link.length > 5) {
      setValid(false);
    }
  }, [updateForm]);

  const showData = () => {
    setDisplay([]);
    if (db) {
      const tx = db.transaction(["links"], "readonly");
      const pNotes = tx.objectStore("links");
      const request = pNotes.openCursor();
      request.onsuccess = (e) => {
        const cursor = e.target.result;
        if (cursor) {
          const note = {
            title: cursor.value.title,
            desc: cursor.value.desc,
            id: cursor.value.id,
            date: cursor.value.date,
          };
          setDisplay((display) => [...display, note].reverse());

          cursor.continue();
        }
      };
    }
  };
  const addData = () => {
    const data = {
      title: addForm.title,
      desc: addForm.link,
      date: fullDate,
    };

    const tx = db.transaction("links", "readwrite");
    const pNotes = tx.objectStore("links");
    pNotes.add(data);
    setAddModal(false);
    setAddForm(defaultData);
    showData();
  };
  const updateData = () => {
    const data = {
      id: currentId,
      title: updateForm.title,
      desc: updateForm.link,
      date: fullDate,
    };
    const tx = db.transaction(["links"], "readwrite");
    const uNotes = tx.objectStore("links");
    let request = uNotes.put(data);
    request.onsuccess = () => {
      setUpdateModal(false);
      setUpdateForm(defaultData);
      setCurrentId("");
      showData();
    };
  };
  const exportToCSV = () => {
    if (!db) return;

    const tx = db.transaction(["links"], "readonly");
    const store = tx.objectStore("links");
    const request = store.getAll();

    request.onsuccess = () => {
      const items = request.result;
      if (!items.length) {
        alert("No data to export.");
        return;
      }

      const csvRows = [];
      // Header row with ID
      csvRows.push(["ID", "Title", "Link", "Date"]);

      // Data rows
      items.forEach((item) => {
        csvRows.push([item.id, item.title, item.desc, item.date]);
      });

      // Convert to CSV format
      const csvContent = csvRows
        .map((row) =>
          row
            .map((cell) => `"${cell?.toString().replace(/"/g, '""')}"`)
            .join(",")
        )
        .join("\n");

      // Download CSV
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `links_export_${new Date().toISOString().split("T")[0]}.csv`;
      a.click();
      URL.revokeObjectURL(url);
    };
  };
  const importFromCSV = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
      const text = event.target.result;
      const lines = text.trim().split("\n");

      if (lines.length < 2) {
        alert("CSV is empty or missing headers.");
        return;
      }

      // Assumes headers are: ID,Title,Link,Date
      const headers = lines[0]
        .split(",")
        .map((h) => h.trim().replace(/"/g, ""));
      const idIndex = headers.indexOf("ID");
      const titleIndex = headers.indexOf("Title");
      const descIndex = headers.indexOf("Link");
      const dateIndex = headers.indexOf("Date");

      const tx = db.transaction(["links"], "readwrite");
      const store = tx.objectStore("links");

      for (let i = 1; i < lines.length; i++) {
        const cells = lines[i]
          .split(",")
          .map((cell) => cell.replace(/^"|"$/g, "").replace(/""/g, '"'));
        const data = {
          id: cells[idIndex],
          title: cells[titleIndex],
          desc: cells[descIndex],
          date: cells[dateIndex],
        };
        store.put(data); // insert or update
      }

      tx.oncomplete = () => {
        alert("CSV data imported successfully!");
        showData();
      };

      tx.onerror = () => {
        alert("Error importing data.");
      };
    };

    reader.readAsText(file);
  };

  return (
    <div>
      <Navbar active="2" />
      <div className={styles.notesBox}>
        <div className={styles.addBox}>
          <h1>
            Links <b>({display.length})</b>
          </h1>
          <button
            className={styles.addBtn}
            onClick={() => {
              setAddModal(true);
            }}
          >
            <i className="fa-solid fa-link"></i> &nbsp;Add Link
          </button>
        </div>
        <div style={{ margin: "12px 0" }}>
          <button className={link.exportBtn} onClick={exportToCSV}>
            <i className="fa-solid fa-file-csv"></i> &nbsp;Export CSV
          </button>
          <input
            type="file"
            style={{ display: "none" }}
            id="csvInput"
            onChange={(e) => importFromCSV(e)}
          />
          <label htmlFor="csvInput" className={link.importBtn}>
            <i className="fa-solid fa-file-import"></i> &nbsp;Import CSV
          </label>
        </div>

        <div className={styles.searchBox}>
          <div className={styles.icon}>
            <i className="fa-solid fa-magnifying-glass"></i>
          </div>
          <input
            type="text"
            placeholder="Search link here..."
            onChange={(ev) => {
              filterDataLink(ev.target.value);
            }}
          ></input>
        </div>
      </div>
      <div className={link.linkBox} id="links">
        {display.map((e, index) => (
          <div className={link.card} key={index}>
            <div className={link.title}>
              <button className={link.remove}>
                <i
                  className="fas fa-trash"
                  onClick={() => {
                    let transaction = db.transaction(["links"], "readwrite");
                    let request = transaction.objectStore("links").delete(e.id);
                    request.onsuccess = () => {
                      showData();
                    };
                  }}
                ></i>
              </button>
              <h1>{e.title}</h1>
            </div>
            <p>{e.date}</p>
            <a target="_blank" href={e.desc} rel="noreferrer">
              {e.desc}
            </a>
            <button
              className={link.edit}
              onClick={() => {
                setUpdateModal(true);
                setUpdateForm({
                  title: e.title,
                  link: e.desc,
                });
                setCurrentId(e.id);
              }}
            >
              <i className="fas fa-pen"></i>
            </button>
          </div>
        ))}
      </div>
      {/* Modal For Update */}
      <div
        className={updateModal ? `${modalStyle.modal}` : `${modalStyle.hide}`}
      >
        <div className={modalStyle.body}>
          <div className={modalStyle.head}>
            <h1>Update Link</h1>
            <div
              className={modalStyle.close}
              onClick={() => {
                setUpdateModal(false);
                setValid(true);
              }}
            >
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
          <div className={modalStyle.form}>
            <input
              type="text"
              placeholder="Link name.."
              onInput={(e) => {
                setUpdateForm({ ...updateForm, title: e.target.value });
              }}
              value={updateForm.title}
            />
            <input
              type="text"
              placeholder="Paste link here.."
              onChange={(e) => {
                setUpdateForm({ ...updateForm, link: e.target.value });
              }}
              value={updateForm.link}
            ></input>
            <button disabled={valid} onClick={updateData}>
              Update
            </button>
          </div>
        </div>
      </div>
      {/* Modal For Add */}
      <div className={addModal ? `${modalStyle.modal}` : `${modalStyle.hide}`}>
        <div className={modalStyle.body}>
          <div className={modalStyle.head}>
            <h1>Add Link</h1>
            <div
              className={modalStyle.close}
              onClick={() => {
                setAddModal(false);
              }}
            >
              <i className="fa-solid fa-xmark"></i>
            </div>
          </div>
          <div className={modalStyle.form}>
            <input
              type="text"
              placeholder="Link name.."
              onInput={(e) => {
                setAddForm({ ...addForm, title: e.target.value });
              }}
              value={addForm.title}
            />
            <input
              type="text"
              placeholder="Paste link here.."
              onInput={(e) => {
                setAddForm({ ...addForm, link: e.target.value });
              }}
              value={addForm.link}
            ></input>
            <button disabled={valid} onClick={addData}>
              Add Link
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checklist;
